/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as GameUtils from "../../GameUtils";
import * as _ from "lodash";

import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";
import SoundManager from "../../SoundManager";

export class Tortoise extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const tortoise = new CustomAnimatedSprite(0,0, resources, R.spines.tortoise)

    this.tortoise = tortoise

    this.addChild(tortoise)
    this.normal()
  }

  removeAllChild(){
    this.removeChildren()
  }

  retracting(){
    return Rx.Observable.create((obs) => {
      this.tortoise.playAnimation(R.spines.tortoise.animations.retracting, false, () => {
        obs.next()
        obs.complete()
        this._tween = new TWEEN.Tween(this)
          .to({y: this.y - 10}, 1000)
          .repeat(Infinity)
          .yoyo(true)
          .easing(TWEEN.Easing.Linear.None)
          .onComplete(() => {
          })
          .start()
      })
    })
  }

  walking(duration, offset){
    return Rx.Observable.create((obs) => {
      this.tortoise.playAnimation(R.spines.tortoise.animations.walking, true)

      this._tween = new TWEEN.Tween(this)
        .to({x: this.x - 1600 + offset}, duration)
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          obs.next()
          obs.complete()
        })
        .start()

      this._tween = new TWEEN.Tween(this)
        .to({y: 1450}, duration)
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
        })
        .start()
    })
  }

  normal(){
    this.tortoise.playAnimation(R.spines.tortoise.animations.idle, true)
  }

  addOnClickListener(fn) {
    this.interactive = true
    this.buttonMode = true

    this
      .on('mousedown', () => {
      })
      .on('touchstart', () => {
      })
      .on('mouseout', () => {
      })
      .on('mouseover', () => {
      })
      .on('mouseup', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
      .on('touchend', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
  }

  removeOnClickListener(){
    this.interactive = false
    this.buttonMode = false

    this
      .removeListener('mousedown')
      .removeListener('touchstart')
      .removeListener('mouseup')
      .removeListener('touchend')
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/level3/Tortoise.js